/**
 * The compliance workspace's header — the space's one topbar, not a second
 * bar under it. The layout mounts it where every other space mounts its
 * `workspace-topbar`, so this space has exactly as many header rows as
 * Settings or Chat: one. It says where you are ("Compliance", then the
 * section); search lives in the sidebar ("/") and the strip above (Mod+K).
 * Probe moved to Apps.
 *
 * @module components/regulation/RegulationHeader
 */
export interface RegulationHeaderProps {
  /** The section under "Compliance" in the breadcrumb; null on the overview. */
  readonly section: string | null;
}

export function RegulationHeader({ section }: RegulationHeaderProps) {
  return (
    <nav aria-label="Breadcrumb" className="hidden min-w-0 shrink-0 sm:block">
      <ol className="flex items-center gap-1.5 text-sm">
        <li className="shrink-0 font-medium text-foreground">Compliance</li>
        {section !== null && (
          <>
            <li aria-hidden className="shrink-0 text-muted-foreground/50">
              /
            </li>
            <li className="min-w-0 truncate text-muted-foreground">{section}</li>
          </>
        )}
      </ol>
    </nav>
  );
}
